// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disclaimer {
    position: fixed;
    inset: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
}

.disclaimer__overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(3px);
}

.disclaimer__modal {
    position: relative;
    z-index: 10000;
    width: 90%;
    max-width: 520px;
    background: var(--color-component-background);
    color: var(--color-component-foreground);
    border-radius: var(--border-radius);
    padding: 2rem 2rem 2.25rem;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
    animation: fadeIn 0.25s ease-out;
}

.disclaimer__title {
    font-size: 1.75rem;
    margin-bottom: 1rem;
    text-align: center;
}

.disclaimer__intro {
    font-size: 1rem;
    line-height: 1.55;
    margin-bottom: 1.25rem;
}

.disclaimer__links p {
    margin: 0.35rem 0;
}

.disclaimer__links a {
    color: #0b63ce;
    text-decoration: none;
}

    .disclaimer__links a:hover,
    .disclaimer__links a:focus {
        text-decoration: underline;
    }

.disclaimer__checkbox {
    display: flex;
    align-items: flex-start;
    gap: 0.6rem;
    margin-top: 1.25rem;
    margin-bottom: 1.5rem;
    font-size: 0.95rem;
    line-height: 1.4;
    cursor: pointer;
}

    .disclaimer__checkbox input {
        margin-top: 0.2rem;
        cursor: pointer;
    }

.disclaimer__button {
    width: 100%;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    border: none;
    border-radius: 8px;
    background: #0b63ce;
    color: #ffffff;
    cursor: pointer;
    transition: background 0.15s ease-out;
}

    .disclaimer__button:disabled {
        background: #9bb8d6;
        cursor: not-allowed;
    }

    .disclaimer__button:not(:disabled):hover {
        background: #084fa6;
    }

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(6px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 480px) {
    .disclaimer__modal {
        padding: 1.5rem 1.25rem 1.75rem;
    }

    .disclaimer__title {
        font-size: 1.5rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/assets/Documents/css/FirstUseDisclaimer.css"],"names":[],"mappings":"AAEA;IACI,eAAe;IACf,QAAQ;IACR,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,6CAA6C;IAC7C,wCAAwC;IACxC,mCAAmC;IACnC,0BAA0B;IAC1B,2CAA2C;IAC3C,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;IAEI;;QAEI,0BAA0B;IAC9B;;AAEJ;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;IAEI;QACI,kBAAkB;QAClB,eAAe;IACnB;;AAEJ;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,qCAAqC;AACzC;;IAEI;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;AAEJ;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["@import '../../../css/App.css';\r\n\r\n.disclaimer {\r\n    position: fixed;\r\n    inset: 0;\r\n    z-index: 2;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.disclaimer__overlay {\r\n    position: absolute;\r\n    inset: 0;\r\n    background: rgba(0, 0, 0, 0.45);\r\n    backdrop-filter: blur(3px);\r\n}\r\n\r\n.disclaimer__modal {\r\n    position: relative;\r\n    z-index: 10000;\r\n    width: 90%;\r\n    max-width: 520px;\r\n    background: var(--color-component-background);\r\n    color: var(--color-component-foreground);\r\n    border-radius: var(--border-radius);\r\n    padding: 2rem 2rem 2.25rem;\r\n    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);\r\n    animation: fadeIn 0.25s ease-out;\r\n}\r\n\r\n.disclaimer__title {\r\n    font-size: 1.75rem;\r\n    margin-bottom: 1rem;\r\n    text-align: center;\r\n}\r\n\r\n.disclaimer__intro {\r\n    font-size: 1rem;\r\n    line-height: 1.55;\r\n    margin-bottom: 1.25rem;\r\n}\r\n\r\n.disclaimer__links p {\r\n    margin: 0.35rem 0;\r\n}\r\n\r\n.disclaimer__links a {\r\n    color: #0b63ce;\r\n    text-decoration: none;\r\n}\r\n\r\n    .disclaimer__links a:hover,\r\n    .disclaimer__links a:focus {\r\n        text-decoration: underline;\r\n    }\r\n\r\n.disclaimer__checkbox {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 0.6rem;\r\n    margin-top: 1.25rem;\r\n    margin-bottom: 1.5rem;\r\n    font-size: 0.95rem;\r\n    line-height: 1.4;\r\n    cursor: pointer;\r\n}\r\n\r\n    .disclaimer__checkbox input {\r\n        margin-top: 0.2rem;\r\n        cursor: pointer;\r\n    }\r\n\r\n.disclaimer__button {\r\n    width: 100%;\r\n    padding: 0.75rem 1rem;\r\n    font-size: 1rem;\r\n    border: none;\r\n    border-radius: 8px;\r\n    background: #0b63ce;\r\n    color: #ffffff;\r\n    cursor: pointer;\r\n    transition: background 0.15s ease-out;\r\n}\r\n\r\n    .disclaimer__button:disabled {\r\n        background: #9bb8d6;\r\n        cursor: not-allowed;\r\n    }\r\n\r\n    .disclaimer__button:not(:disabled):hover {\r\n        background: #084fa6;\r\n    }\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(6px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .disclaimer__modal {\r\n        padding: 1.5rem 1.25rem 1.75rem;\r\n    }\r\n\r\n    .disclaimer__title {\r\n        font-size: 1.5rem;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
